import { render, staticRenderFns } from "./BloqueioModal.vue?vue&type=template&id=7819218d"
import script from "./BloqueioModal.vue?vue&type=script&lang=js"
export * from "./BloqueioModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports